import DepositStatement from '../depositstatement/depositstatement'

const WithdrawStatement = () => {
  return <DepositStatement />
}

export default WithdrawStatement
